export const environment = {
  production: false,
  baseUrl: 'https://t16sejszfh.execute-api.us-east-1.amazonaws.com/qa'
};
